<template>
  <v-sheet color="transparent" class="card__label" :class="'mx-n' + extendX">
    <div class="card__label__wrap">
      <v-card-text class="py-3 text--secondary" :class="classes">
        <slot> Label </slot>
      </v-card-text>
      <div class="card__label__actions__group" :class="extendX > 0 ? 'mr-' + (extendX + 2) : 'mr-2'">
        <slot name="btn-text"></slot>
        <slot name="btn-icon"></slot>
        <slot name="btn-overflow"></slot>
      </div>
    </div>
    <v-divider v-if="!hideDivider"></v-divider>
  </v-sheet>
</template>

<script>
export default {
  name: "CardLabelBar",
  props: {
    extendX: {
      type: Number,
      default: 0,
    },
    boldText: {
      type: Boolean,
      default: false,
    },
    hideDivider: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      var classesCombined = "";
      if (this.boldText) {
        classesCombined = classesCombined + "text-subtitle-2";
      } else {
        classesCombined = classesCombined + "text-body-2";
      }
      return classesCombined;
    },
  },
};
</script>

<style lang="sass" scoped>
.card__label
  .card__label__wrap
    align-items: center
    display: flex
    flex: 1 1 100%
    min-height: 52px

    .v-card__text
      align-items: center
      align-self: center
      display: flex
      flex-wrap: wrap
      flex: 1 1
      overflow: hidden
</style>

<style lang="sass">
.card__label
  .card__label__wrap
    .card__label__actions__group
      > .v-btn
        margin-left: 4px
</style>